export default __webpack_public_path__ + "static/ak-cached/24h/media/TV.6b0afc41.png";